"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpPlatformPublicConfig = exports.getDealManagementEnabled = exports.getSpPlatformConfig = undefined;

var _constants = require("../constants");

var getSpPlatformConfig = exports.getSpPlatformConfig = function (subDomain) {
  return {
    type: _constants.ActionTypes.GET_SP_PLATFORM_CONFIG,
    payload: {
      subDomain: subDomain
    }
  };
};

var getDealManagementEnabled = exports.getDealManagementEnabled = function () {
  return {
    type: _constants.ActionTypes.GET_DEAL_MANAGEMENT_ENABLED_REQUEST
  };
};

var getSpPlatformPublicConfig = exports.getSpPlatformPublicConfig = function (subDomain) {
  return {
    type: _constants.ActionTypes.GET_SP_PLATFORM_PUBLIC_CONFIG,
    payload: {
      subDomain: subDomain
    }
  };
};